// extracted by mini-css-extract-plugin
module.exports = {"page":"CommunityPage_page__38fY_"};